<template>
    <div class="bank-award">
        <h1 class="title">金融科技发展奖</h1>
        <ul class="content">
            <li
                v-for="item in jdAds"
                :key="item.id"
                @click="openLink(item.content)"
            >
                <img :src="item.icon">
            </li>
        </ul>
    </div>
</template>

<script>
const jdAds = [
    {
        "id": "179d7618b85e44548289fe84121a2c7b",
        "icon": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/jinrong/jinrong_01.png",
        "content": "https://izt.eastfair.cn/h5-web/#/jrdetail?type=1"
    },
    {
        "id": "5c703ea468ea4082925c00227b70ccb4",
        "icon": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/jinrong/jinrong_02.png",
        "content": "https://izt.eastfair.cn/h5-web/#/player?video=aHR0cHM6Ly9lZi1pbWFzdGVyLWZpbGUub3NzLWNuLWJlaWppbmcuYWxpeXVuY3MuY29tL2l6dF92aWRlby9qaW5yb25nLzkuMjQlMjAlRTQlQjglOEElRTUlOEQlODglRTklQTIlODElRTUlQTUlOTYlRTclOEUlQUYlRTglOEElODIubXA0&vid=v3163yqaq03&type=base64"
    },
    {
        "id": "1ad3b7c406cf434aaa6c6f73ceefb749",
        "icon": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/jinrong/jinrong_03.png",
        "content": "https://izt.eastfair.cn/h5-web/#/lookback"
    },
    {
        "id": "02901989f0b649358bfa3d78d872815d",
        "icon": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/jinrong/jinrong_04.jpg",
        "content": "https://izt.eastfair.cn/h5-web/#/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/opening/act2.png"
    }
]

export default {
    data() {
        return {
            jdAds
        }
    },
    methods: {
        openLink(url) {
            window.open(url, '_blank')
        }
    }
}
</script>

<style scoped>
.bank-award {
    max-width: 700px;
    margin: 0 auto;
}
.bank-award .title {
    font-size: 20px;
    text-align: center;
}
.bank-award .content {
    padding: 0 14px;
}
.bank-award .content li {
    width: 100%;
    font-size: 0;
    margin-bottom: 18px;
    border-radius: 4px;
    overflow: hidden;
}
.bank-award .content li img {
    width: 100%;
}
</style>